module.exports = __webpack_public_path__ + "static/img/reset.040d5ae0.png";